import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import TasksSection from "./DashboardUtils/TasksSection.jsx";
import RecentNotesSection from "./DashboardUtils/RecentNotesSection.jsx";
import TasksSummary from "./DashboardUtils/TasksSummary.jsx";
import InviteSection from "./DashboardUtils/InviteSection.jsx";
import StatisticsSection from "./DashboardUtils/StatisticsSection.jsx";
import TopBar from "./DashboardUtils/TopBar.jsx";
import InviteModal from "./Modals/Dashboard/EmailInviteModal.jsx";
import { useSubscriptions } from "../contexts/subscriptionsContext.js";
import SubscriptionAlertModal from "./Modals/SubscriptionAlertModal";
import { useUserInfo } from "../contexts/userInfo.js";

const DashboardWrapper = styled.div`
  width: 100%;
  padding: 0 24px 24px 24px;
  box-sizing: border-box;

  @media (max-width: 992px) {
    padding: 16px;
  }

  @media (max-width: 576px) {
    padding: 12px 10px;
  }
`;

const DashboardContainer = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 420px);
  gap: 24px;
  align-items: flex-start;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`;

const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
`;

const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;

  @media (max-width: 1200px) {
    order: -1;
  }
`;

const DashboardPage = () => {
  const { userInfo } = useUserInfo();
  const [inviteOpen, setInviteOpen] = useState(false);
  const [showSubscriptionAlert, setShowSubscriptionAlert] = useState(false);

  useEffect(() => {
    if (!userInfo?.user_id) return;
    const userKey = `subscriptionAlertShown_${userInfo?.user_id}`;
    const hasShown = localStorage.getItem(userKey);

    if (!hasShown) {
      setShowSubscriptionAlert(true);
      localStorage.setItem(userKey, "true");
    }
  }, [userInfo]);

  return (
    <DashboardWrapper>
      {showSubscriptionAlert && (
        <SubscriptionAlertModal
          onClose={() => setShowSubscriptionAlert(false)}
        />
      )}
      <DashboardContainer>
        <LeftColumn>
          <TasksSection />
          <RecentNotesSection />
        </LeftColumn>

        <RightColumn>
          <TasksSummary />
          {/* <StatisticsSection /> */}
          <InviteSection
            inviteOpen={inviteOpen}
            setInviteOpen={setInviteOpen}
          />
        </RightColumn>
      </DashboardContainer>
    </DashboardWrapper>
  );
};

export default DashboardPage;
